<template>
	<div class="container-fluid">
		<div class="m-2">
      		<div class="alert alert-primary h4 text-center">
          		<linkto :link="'/customers/search'"/>
          		Ügyfél rendelés történet
      		</div>
    	</div>
    	<div class="row d-flex justify-content-center align-items-center">
    		<div class="col-12 text-center">
    			<p>
    				Ügyfél:
    				{{customer.nev}}
    			</p>
    		</div>
    		<div class="col-12">
    			<table class="table table-responsive table-striped">
    				<thead>
    					<tr>
    						<th>Rögzítette</th>
    						<th>Rögzítve</th>
    						<th>Termék</th>
    						<th>Megjegyzés</th>
    						<th>DB</th>
    						<th>Ár</th>
    						<th>Összesen</th>
    						<th>Számlázva</th>
    						<th>Aktív</th>
    						<th>Lezárta</th>
    					</tr>
    				</thead>
    				<tbody>
    					<tr
    						v-for="(v,k) in list"
    						:key="v.id"
    						:class="[
    							v.aktiv==='1'?'bg-danger':''
    						]"
    					>
    						<td>{{v.user}}</td>
    						<td>{{v.datum}}</td>
    						<td>{{v.termek}}</td>
    						<td>{{v.rendmegj}}</td>
    						<td>{{v.db}}</td>
    						<td>{{v.ar}}</td>
    						<td>{{v.db * v.ar | huf}} Ft</td>
    						<td>{{v.szamlazva===1?'Igen':'Nem'}}</td>
    						<td>{{v.aktiv==='0'?'Nem':'Aktív'}}</td>
    						<td>{{v.lezarta}}</td>
    					</tr>
    				</tbody>
    			</table>
    		</div>
    	</div>
	</div>
</template>
<script type="text/javascript">
export default {
	data() {
		return {
			id: 0,
			list: [],
			customer: {}
		}
	},

	mounted() {
		this.id = this.$route.params.id
		this.cusLoad()
		this.rendLoad()
	},

	methods: {
		cusLoad() {
			this.$Progress.start()
			this.req.post('/customers/getdata/', {
				id: this.id
			})
				.then(res => {
					this.customer = res.data.customer
					this.$Progress.finish()
				})
				.catch(err => {
					toastr.error(res.data.text || 'Hiba az ügyfél adatok betöltése közben')
					this.$Progress.fail()
				})
		},

		rendLoad() {
			this.$Progress.start()
			this.req.post('/orders/customer/' + this.id, {
				id: this.id
			})
				.then(res => {
					this.list = res.data.list
					this.$Progress.finish()
				})
				.catch(err => {
					toastr.error(res.data.text)
					this.$Progress.fail()
				})
		}
	}
}
</script>


// WEBPACK FOOTER //
// src/components/customers/history.vue